import { CILogger } from 'common/log/log.provider';

import type { DeviceHandoffActionType } from './constants';
import type { DeviceHandoffPhase } from './types';

export function warnIllegalTransition(phase: DeviceHandoffPhase, event: DeviceHandoffActionType): void {
    CILogger.getInstance().error(`device handoff: illegal transition "${event}" from phase "${phase}"`);
}
